/**
 * Извлекает ID заказа из URL вида /booking/{orderId}/...
 * @param pathname - путь из location.pathname
 * @returns orderId или null, если не найден
 */
export const extractOrderIdFromPathname = (pathname) => {
    var _a;
    const match = pathname.match(/\/booking\/(\d+)\//);
    return (_a = match === null || match === void 0 ? void 0 : match[1]) !== null && _a !== void 0 ? _a : null;
};
